// Description: This file contains the initialization code for the policy portal.
//
//TODO: Requires updates to make the code ES6 compliant and remove jQuery dependencies.

initPolicyPortal();

function initPolicyPortal() {
    if (!document.body.classList.contains('theme-' + configTheme)) {
        document.body.classList.add('theme-' + configTheme);
    }
    $(document).ready(function () { setupPolicyPortal(); });
}

function setupPolicyPortal() {
    setupGlobal();
    setupAccessibility();
    //setupFaq();
    if (configEnableSidebarTabRowReordering) { setupSidebarTabSwapping(); }
    setupPolicyEditor();
    setupRadEditorFields();
    setCookiePolicyVisibility();
}

//setup functions
function setupGlobal() {
    window.addEventListener("beforeunload", function (e) {
        window.sessionStorage.tabId = window.tabId;
    });

    let outerWrapper = document.body;
    //outerWrapper.classList.remove('body-no-scroll');
    addClickByClass("#open-mobile-search", function (event) { $("#mobile-search-panel").fadeToggle(200); });
    addClickByClass("#close-mobile-search", function (event) { $("#mobile-search-panel").fadeToggle(200); });
    addClickByClass(".js-open-notifications-panel", function (event) { openPopup('#popupNotificationsPanel'); });
    addClickByClass(".js-open-my-account-panel", function (event) { openPopup('#popupMyAccountPanel'); });
    addClickByClass(".main-menu__side-nav-toggle", function (event) { toggleSideNav(); });
    addClickByClass("#main-menu-toggle", function (event) {
        $("#main-menu-toggle").toggleClass("open");
        $("#main-menu-mobile").toggle(200);
    });
    setupSubMenus();
    logPageHistory();
    initPersistentPopups();
    //outerWrapper.classList.add('theme-' + configTheme);
}